import React from 'react';
import { CheckIcon, InfoIcon, PackageCheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" aria-labelledby="volumes-title" data-id="element-321" data-mp="2x3cvzud5dpu2">
      <div className="mx-auto max-w-6xl" data-id="element-322" data-mp="2szes76cvnquo">
        <SectionHeading id="volumes-title" lead="Each volume focuses on a specific professional deliverable." data-id="element-323" data-mp="2o13m96ppe0hq">
          Everything you need to build your <span className="text-accent-600" data-id="element-324" data-mp="2j8k8o9r0n5cx">post-laser assessment workflow</span>
        </SectionHeading>

        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-325" data-mp="2eb1wmahpca0p">
          {volumes.map(v => <article key={v.number} className="flex flex-col rounded-3xl bg-mist p-5 ring-1 ring-navy-900/10 sm:p-7" data-id="element-326" data-mp="29dijjdwqq3ac">
              <div className="flex items-center gap-3" data-id="element-327" data-mp="25bwzn8lsgoqn">
                <span className="rounded-lg bg-gold-400 px-3 py-1 font-display text-sm font-black uppercase text-navy-950" data-id="element-328" data-mp="20c2bvdxb8f9t">
                  Volume {v.number}
                </span>
              </div>
              <h3 className="mt-4 font-display text-xl font-black leading-tight text-navy-900 sm:text-2xl" data-id="element-329" data-mp="37x4h02gzas96">{v.title}</h3>
              <p className="mt-2 font-medium text-ink/70" data-id="element-330" data-mp="2u6skzsh9w9cr">{v.tagline}</p>

              <p className="mt-5 text-xs font-bold uppercase tracking-wide text-accent-600" data-id="element-331" data-mp="2y7kt2iees87g">Inside</p>
              <ul className="mt-2 space-y-2" data-id="element-332" data-mp="3lxf918u0ycvx">
                {v.inside.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-ink/85" data-id="element-333" data-mp="3qu5opv1x36gt">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent-500" aria-hidden="true" data-id="element-334" data-mp="3cw8qyvbq8u0k" />
                    {item}
                  </li>)}
              </ul>

              <div className="mt-auto pt-5" data-id="element-335" data-mp="21g0u9aiz8cwt">
                <div className="flex items-start gap-3 rounded-2xl bg-navy-900 p-4 text-white" data-id="element-336" data-mp="21ez6c5gv3vxo">
                  <PackageCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-337" data-mp="26gol9w77gtr1" />
                  <p className="text-sm leading-relaxed" data-id="element-338" data-mp="c19avpd0ci1o">
                    <strong className="block text-gold-300" data-id="element-339" data-mp="713fby3mabeb">Professional Deliverable</strong>
                    {v.deliverable}
                  </p>
                </div>
                {v.note && <p className="mt-3 flex items-start gap-2 text-xs leading-relaxed text-ink/60" data-id="element-340" data-mp="3uc365c42u7ui">
                    <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-341" data-mp="3pf2v0msdeewj" />
                    {v.note}
                  </p>}
              </div>
            </article>)}
        </div>

        <SectionCTA label="I want all 6 volumes" data-id="element-342" data-mp="3fgdn9mu6uau0" />
      </div>
    </section>;
}